import { useCallback, useEffect, useRef, useState } from "react";
import { toBlob } from "html-to-image";
import { toast } from "sonner";

export function useShareSnapshot() {
  const [target, setTarget] = useState(null);
  const cardRef = useRef(null);

  useEffect(() => {
    if (!target || !cardRef.current) return;
    let cancelled = false;
    (async () => {
      try {
        await document.fonts?.ready;
        const blob = await toBlob(cardRef.current, { pixelRatio: 2, cacheBust: true });
        if (cancelled || !blob) return;
        const file = new File([blob], "other-self-snapshot.png", { type: "image/png" });
        if (navigator.canShare?.({ files: [file] })) {
          await navigator.share({ files: [file], title: "Other Self", text: "A conversation across two timelines" });
        } else {
          const url = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), { href: url, download: file.name });
          a.click();
          URL.revokeObjectURL(url);
          toast.success("Snapshot saved as an image");
        }
      } catch (e) {
        if (e.name !== "AbortError") toast.error("Couldn't create the snapshot. Try again.");
      } finally {
        if (!cancelled) setTarget(null);
      }
    })();
    return () => { cancelled = true; };
  }, [target]);

  const share = useCallback((payload) => setTarget(payload), []);
  return { cardRef, target, share, isSharing: Boolean(target) };
}
